'use client';

import type React from 'react';
import { SidebarInset, SidebarTrigger } from '@/app/_components/ui/sidebar';
import {
  AppSidebar,
  AppSidebarProvider,
} from '@/app/dashboard/_components/app-sidebar';
import { Button } from '@/app/_components/ui/button';
import Link from '@/app/_adapters/next-link';
import { usePathname } from '@/app/_adapters/next-navigation';
import { AuthGuard } from '@/app/_components/auth-guard';

function DashboardContent({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <div className="flex min-h-svh w-full">
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger />
          <div className="text-sm text-muted-foreground">MAIA Router</div>
          <div className="ml-auto flex items-center gap-2">
            {pathname !== '/dashboard/billing' && (
              <Link
                className="flex items-center gap-2"
                href="/dashboard/billing"
              >
                <Button
                  size="sm"
                  variant="outline"
                  className="hover:cursor-pointer"
                >
                  Add Credit
                </Button>
              </Link>
            )}
          </div>
        </header>
        <div className="flex-1 overflow-auto p-4">
          <div className="h-full">{children}</div>
        </div>
      </SidebarInset>
    </div>
  );
}

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthGuard>
      <AppSidebarProvider>
        <DashboardContent>{children}</DashboardContent>
      </AppSidebarProvider>
    </AuthGuard>
  );
}
